import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';
import find from 'lodash/find';
import concat from 'lodash/concat';
import merge from 'lodash/merge';

import { rootSiteState } from './state-accessors';

export const rootSiteSelector = createSelector(rootSiteState, (rootSite) => ({
  ...rootSite,
  siteName: get(rootSite, 'name'),
}));

export const siteSelector = createSelector(
  (state) => get(state, 'site', {}),
  (site) => site,
);

// The site a route is on: a child site when the URL carries a slug, the root site otherwise
export const currentSiteSelector = (siteSlug) => (siteSlug ? siteFromRootSiteSelector(siteSlug) : rootSiteSelector);

export const siteFromRootSiteSelector = (siteSlug) =>
  createSelector(rootSiteState, ({ loading, childrenSites = [], sitePro }) => {
    const site = find(concat(childrenSites, sitePro || {}), (site) => site.slug === siteSlug);

    return merge(
      site && {
        ...site,
        siteId: site.id,
        siteName: site.name,
        isAcceptingGiftCard: site.giftCard,
      },
      { loading },
    );
  });

export const visibilitySectionsForSiteSelector = (siteSlug) =>
  createSelector(
    siteSlug ? siteFromRootSiteSelector(siteSlug) : rootSiteState,
    ({ visibilitySections }) =>
      visibilitySections || {
        charitiesSection: true,
        partnershipAndLicensingSection: true,
      },
  );

export const designPathsSelector = createSelector(
  (state) => get(state, 'designPaths', {}),
  (designPaths) => designPaths,
);
